import { styled } from '@mui/material/styles';

// const NAV_WIDTH = 280;
// const COLLAPSED_WIDTH = 66;
const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 64;
// Gap between the bar and page content. Desktop previously used the bar height
// alone, leaving content flush against it.
const CONTENT_GAP = 24;
// Was theme.spacing(5). Spelled out so MAIN_CONTENT_OFFSET below can account for
// it without depending on the theme's spacing unit.
const CONTENT_BOTTOM = 40;

/**
 * Vertical space this layout takes out of the viewport: the app bar, the gap
 * beneath it, and the padding at the foot of the page.
 *
 * Exported so a page that wants to fill the window can size itself with
 * `calc(100vh - MAIN_CONTENT_OFFSET)` against the same numbers, rather than
 * hard-coding a copy that drifts the next time the bar changes height — see
 * GridPageAbstract. The mobile and desktop bars are the same height, so one
 * value covers both.
 */
export const MAIN_CONTENT_OFFSET = APP_BAR_DESKTOP + CONTENT_GAP + CONTENT_BOTTOM;

const MainLayout = styled('div', {
    shouldForwardProp: (prop) => prop !== 'collapsed'
})(({ theme, collapsed }) => ({
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '100%',
    paddingTop: APP_BAR_MOBILE + CONTENT_GAP,
    paddingBottom: CONTENT_BOTTOM,
    // marginLeft: collapsed ? COLLAPSED_WIDTH : NAV_WIDTH,
    transition: 'all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)',
    // willChange: 'padding-left',
    [theme.breakpoints.up('lg')]: {
        paddingTop: APP_BAR_DESKTOP + CONTENT_GAP,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    }
}));

export default MainLayout;
